import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ReactTable from 'react-table'
import _ from 'lodash'
import moment from 'moment'
import Title from '../general/title'
import { pipsyTheme } from '../../graphTheme'
import { Link } from 'react-router-dom'
import { Pie, HorizontalBar, Bar, Line } from 'react-chartjs-2'
import formatPhoneNumber from '../../helpers/formatPhone'


class Rolling5 extends Component {

	netBars = () => {
		const data = {
			labels: ['Bryson', 'Cross Creek Ranch', 'Grand Central Park'],
			datasets: [
				{
					label: "Projected vs. Actual",
					data: [-1, 3, 5],
					type: 'line',
					fill: false,
					backgroundColor:'#465829',
					borderColor:'#465829',
					pointRadius: 10,
					pointHoverRadius: 10
				},
				{
					label: "2018",
					backgroundColor: '#3295EC',
					borderColor: '#3295EC',
					borderWidth: 1,
					hoverBackgroundColor: 'rgba(50,149,236,0.5)',
					hoverBorderColor: 'rgba(50,149,236,0.9)',
					data: [3, 7, 4]
				},
				{
					label: "2018 Projected",
					backgroundColor: '#76B9F1',
					borderColor: '#3295EC',
					borderWidth: 1,
					hoverBackgroundColor: 'rgba(50,149,236,0.5)',
					hoverBorderColor: 'rgba(50,149,236,0.9)',
					data: [4, 3, 5]
				},
				{
					label: "2019 Actual",
					backgroundColor: '#C297F5',
					borderColor: '#8f6fb5',
					borderWidth: 1,
					hoverBackgroundColor: 'rgba(50,149,236,0.5)',
					hoverBorderColor: 'rgba(50,149,236,0.9)',
					data: [7, 2, 6]
				}
			]
		}

		const opts = {
			scales: {
				xAxes: [{
					
				}],
				yAxes: [{

				}]
			},
			legend: {
				display: true,
				position: 'top'
			},
			plugins: {
				// Change options for ALL labels of THIS CHART
				datalabels: {
					color: 'white'
				}
			}
		}

		return (<Bar data={data} options={opts} />)
	}

	totals = () => {
		const data = {
			labels: ['Bryson', 'Cross Creek Ranch', 'Grand Central Park'],
			datasets: [
				{
					label: "Projected vs. Actual",
					data: [-1, 3, 5],
					type: 'line',
					fill: false,
					backgroundColor:'#465829',
					borderColor:'#465829',
					pointRadius: 10,
					pointHoverRadius: 10
				},
				{
					label: "2018",
					backgroundColor: '#3295EC',
					borderColor: '#3295EC',
					borderWidth: 1,
					hoverBackgroundColor: 'rgba(50,149,236,0.5)',
					hoverBorderColor: 'rgba(50,149,236,0.9)',
					data: [3, 7, 4]
				},
				{
					label: "2018 Projected",
					backgroundColor: '#76B9F1',
					borderColor: '#3295EC',
					borderWidth: 1,
					hoverBackgroundColor: 'rgba(50,149,236,0.5)',
					hoverBorderColor: 'rgba(50,149,236,0.9)',
					data: [4, 3, 5]
				},
				{
					label: "2019 Actual",
					backgroundColor: '#C297F5',
					borderColor: '#8f6fb5',
					borderWidth: 1,
					hoverBackgroundColor: 'rgba(50,149,236,0.5)',
					hoverBorderColor: 'rgba(50,149,236,0.9)',
					data: [7, 2, 6]
				}
			]
		}

		const opts = {
			scales: {
				xAxes: [{
					
				}],
				yAxes: [{

				}]
			},
			legend: {
				display: true,
				position: 'top'
			},
			plugins: {
				// Change options for ALL labels of THIS CHART
				datalabels: {
					color: 'white'
				}
			}
		}

		return (<HorizontalBar data={data} options={opts} />)
	}

	developerLots = () => {
		var count = 0
		if (_.has(this.props.payload.allLots, 'geojson.features')) {
			_.forEach(this.props.payload.allLots.geojson.features, (r) => {
				if (r.properties.Status == 'Off-Market') { count++ }
			})
			return count
		}
		return 0
	}

	specHomesTotal = () => {
		var count = 0
		if (_.has(this.props.payload.allLots, 'geojson.features')) {
			_.forEach(this.props.payload.allLots.geojson.features, (r) => {
				if (r.properties.Status == 'Available Home') { count++ }
			})
			return count
		}
		return 0
	}

	comingSoon = () => {
		var count = 0
		if (_.has(this.props.payload.allLots, 'geojson.features')) {
			_.forEach(this.props.payload.allLots.geojson.features, (r) => {
				if (r.properties.Status == 'Coming Soon') { count++ }
			})
			return count
		}
		return 0
	}

	buildTable = () => {
		return [{
				image: '/playground/bryson.png',
				community: 'Bryson',
				'2014': 0,
				'2015': 4,
				'2016': 27,
				'2017': 51,
				'2018': 78,
				'2019': 33,
				total: 193,
				sixMonth: 2.1,
				netSales: 4,
				completion: 65,
				lastVsCurrent: '+5'
			},
			{
				image: '/playground/cross-creek.png',
				community: 'Cross Creek Ranch',
				'2014': 418,
				'2015': 334,
				'2016': 377,
				'2017': 397,
				'2018': 455,
				'2019': 164,
				total: 2145,
				sixMonth: 10.3,
				netSales: 10,
				completion: 70,
				lastVsCurrent: '+25'
			},
			{
				image: '/playground/grand-central.png',
				community: 'Grand Central Park',
				'2014': 0,
				'2015': 0,
				'2016': 15,
				'2017': 98,
				'2018': 117,
				'2019': 27,
				total: 257,
				sixMonth: 1.7,
				netSales: 3,
				completion: 22,
				lastVsCurrent: '-11'
			},
		]
	}

	findSection = (id) => {
		var ret = false
		if (_.has(this.props.payload.allLots, 'geojson.features')) {
			_.forEach(this.props.payload.allLots.geojson.features, (r) => {
				if (r.properties.entry_id == id) { ret = r.properties.Section }
			})
			//return count
		}

		return ret
	}

	render() {
		const columns = [{
				Header: 'Image',
				accessor: 'image',
				Cell: (row) => {
					return <div className="ReactTable__logoCont"><img src={row.original.image} className="ReactTable__logo" /></div>
				}
			},
			{
				Header: 'Community',
				accessor: 'community',
				minWidth: 150,
				Cell: (row) => {
					return (<strong>{row.value}</strong>)
				},
				Footer: 'Total'
			},
			{
				Header: '2014',
				accessor: '2014',
				minWidth: 60,
				Cell: (row) => {
					return row.value.toLocaleString()
				},
				Footer: '418'
			},
			{
				Header: '2015',
				accessor: '2015',
				minWidth: 60,
				Cell: (row) => {
					return row.value.toLocaleString()
				},
				Footer: '338'
			},
			{
				Header: '2016',
				accessor: '2016',
				minWidth: 60,
				Cell: (row) => {
					return row.value.toLocaleString()
				},
				Footer: '419'
			},
			{
				Header: '2017',
				accessor: '2017',
				minWidth: 60,
				Cell: (row) => {
					return row.value.toLocaleString()
				},
				Footer: '546'
			},
			{
				Header: '2018',
				accessor: '2018',
				minWidth: 60,
				Cell: (row) => {
					return row.value.toLocaleString()
				},
				Footer: '650'
			},
			{
				Header: '2019',
				accessor: '2019',
				minWidth: 60,
				Cell: (row) => {
					return row.value.toLocaleString()
				},
				Footer: '224'
			},
			{
				Header: 'Totals',
				accessor: 'total',
				minWidth: 70,
				Cell: (row) => {
					return row.value.toLocaleString()
				},
				Footer: '2,595'
			},
			{
				Header: '',
				accessor: 'gutter',
				className: 'ReactTable__gutter',
				//headerClassName: 'ReactTable__gutter',
				maxWidth: 10,
				sortable: false,
				filterable: false,
			},
			{
				Header: '6 Month Rolling Average',
				accessor: 'sixMonth',
				Footer: '14.1'
			},
			{
				Header: 'Net Sales Week 16',
				accessor: 'netSales',
				Footer: '17'
			},
			{
				Header: 'Last Year vs Current Year',
				accessor: 'lastVsCurrent',
				Footer: '+19'
			},
			{
				Header: 'Completion Status',
				accessor: 'completion',
				Cell: (row) => {
					return (
						<div className="ReactTable__progressCont">
							<div
								className="ReactTable__progress"
								style={{
								width: `${row.value}%`,
								backgroundColor: row.value > 66 ? '#85cc00'
									: row.value > 33 ? '#ffbf00'
									: '#ff2e00',
								}}
							/>
							</div>
					)
				}
			}
		]
		return (
			<div className="inventory">
				<Title title="Rolling 5 Year Summary" showDate={false} />
				<div className="content">
					<ReactTable
						data={this.buildTable()}
						columns={columns}
						defaultPageSize={3}
						loadingText=""
						defaultSorted={[
							{
								id: "community",
								asc: true,
							},
						]}
					/>
				</div>
				<div className="content">
					<h2>Net Sales to Date - Week 16</h2>
					{this.netBars()}
				</div>
				{/*<div className="content">
					<h2>JDC Total Home Sales</h2>
					{this.totals()}
				</div>*/}
			</div>
		)
	}

}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Rolling5)